import apibase from './BaseAPI';

const search = async (params) => {
    try {
        const res = await apibase.post('/announcement/search', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const save = async (params) => {
    try {
        const res = await apibase.post('/announcement/save', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const update = async (params) => {
    try {
        const res = await apibase.post('/announcement/update', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const getById = async (params) => {
    try {
        const res = await apibase.post('/announcement/getById', params)
        return res.data

    } catch (err) {
        throw err
    }
}

// user (announcement) read receipt
const getUnreadAnnouncementById = async (params) => {
    try {
        const res = await apibase.post('/userReadReceipt/getUnreadAnnouncementById', params)
        return res.data

    } catch (err) {
        throw err
    }
}

const updateUserReadReceipt = async (params) => {
    try {
        const res = await apibase.post('/userReadReceipt/upsert', params)
        return res.data

    } catch (err) {
        throw err
    }
}


export default {
    search: search,
    save: save,
    update: update,
    getById: getById,
    getUnreadAnnouncementById: getUnreadAnnouncementById,
    updateUserReadReceipt: updateUserReadReceipt,
}